// require("dotenv").config();

//Here urls will be differernt for dev, test and prod
//SPA(dev) https://devsignin.acep.org/
//SPA(test) https://testsignin.acep.org/
//SPA(prod) https://signin.acep.org/

//local
// const API_URL = 'http://localhost:4000/v1/api'
// export const CMEDashboardURL = 'http://localhost:3000/';

//dev
// const API_URL  = 'https://acep-scus-dev-cme-api.azurewebsites.net/v1/api';
// export const CMEDashboardURL = 'https://acep-scus-dev-cme-ui.azurewebsites.net/';

//test
// const API_URL  =  'https://cmetrackerapisit.acep.org/v1/api'; 
// export const CMEDashboardURL = 'https://cmetrackersit.acep.org/';

//prod
//const API_URL = 'https://cme-api-acep.azurewebsites.net/v1/api';
//export const CMEDashboardURL = 'https://cmemanagement-acep.azurewebsites.net/';

const API_URL = process.env.REACT_APP_API_URL || '';
export const CMEDashboardURL = process.env.REACT_APP_CME_DASHBOARD_URL || '';

//based on this variable, dev, test or prod, we will handle the subsequence URL
export const env = process.env.REACT_APP_ENVIRONMENT;

export const ssoEnvironment = process.env.REACT_APP_SSO_ENVIRONMENT;

//here, we will also add/handle the URL based on the Organizatins like ACEP or SEMPA or EMRA
export const LOGIN_URL = 'https://' + env + 'signin.acep.org/spapi/Saml/InitiateSingleSignOn?returnurl='
export const LOGOUT_URL = 'https://' + env + 'signin.acep.org/spapi/Saml/InitiateSingleLogout?returnurl='

export const CMEAuthorizatioinAPIURL = 'https://' + env + 'signin.acep.org/spapi/api/Authorization'
export const CMEGetContactDetailsAPIURL = 'https://' + env + 'ws.acep.org/aceptoolkit/api/2015/contactdetailsbyid?acepid='
export const CMEContactProfileAPIURL = 'https://' + env + 'ws.acep.org/aceptoolkit/api/2017/contactdetails/profile'


export const CMEAccountURL = 'https://' + env + 'webapps.acep.org/membership/dashboard/';
export const CMECredentialsURL = CMEAccountURL + '#/credentials';
export const CMETrackerURL = 'http://' + env + 'webapps.acep.org/cmetracker/Default.aspx';
export const CMELogoURL = 'https://www.acep.org/globalassets/sites/acep/media/global/acep-logo3x.png';
export const AcepHeaderLogo_RedirectURL = "https://www.acep.org/"
export const MyCME_RedirectURL = "https://cmetracker.acep.org"
export const DefaultNoImageURL = "https://s3.amazonaws.com/user-portraits/none.jpg"
export const AuthorizationCredentials = "Basic Y21lbWFuYWdlbWVudDpQRXh3R0xSdw=="

export const JoinRenewURL = "http://" + env + "webapps.acep.org/memberapplication"

export const HeaderEclipsePhotoURL = "https://s3.amazonaws.com/AcepPortfolio/"

export const OpportunitiesLink = 'https://www.acep.org/education/cme/';
export const ACCME_PARS_URL = 'https://accme.org/data-reporting/state-medical-licensing-boards-collaborations/';
export const CEBROKER_URL = 'https://cebroker.com/professions/physicians';
export const STATE_LICENSING_BOARDS_URL = 'https://www.acep.org/education/cme/cme-tracker-state-reporting';

// Every accreditation site the UI knows about, and every piece of wording that names it —
// single source of truth so ClaimUnclaimCME.tsx, PARSConsentSection.tsx and ModalForm.js read
// from here instead of hardcoding the wording inline.
//
// This map is also the per-environment on/off switch: flip a site's isEnabled to false and it
// disappears from every surface (claim/unclaim banners, the Transcript "Accepted by Boards"
// column, the consent section and its tooltip, the consent modal) without any wording change to
// the sites that remain. With every site disabled the whole accreditation feature switches off
// via FEATURE_ACCREDITATION_ENABLED below.
type AccreditationSite = {
  /** False hides this site everywhere in the UI and stops it being submitted to. */
  isEnabled: boolean;
  /** Banner/toast wording, e.g. "ACCME PARS submission successful." */
  label: string;
  /** Transcript "Accepted by Boards" cell text. */
  boardBadge: string;
  /** CME_Tracking flag marking this site accepted the submission. */
  acceptedFlag: string;
  /** Consent wording without a leading article: "...via ACCME PARS website or CE Broker." */
  consentName: string;
  /** Consent wording with its article: "...via the ACCME PARS website or CE Broker." */
  consentNameArticle: string;
};

export const ACCREDITATION_SITES: Record<string, AccreditationSite> = {
  PARS: {
    isEnabled: true,
    label: 'ACCME PARS',
    boardBadge: 'ACCME',
    acceptedFlag: 'IsACCMEAccreditationAccepted',
    consentName: 'ACCME PARS website',
    consentNameArticle: 'the ACCME PARS website',
  },
  CEBROKER: {
    isEnabled: true,
    label: 'CE Broker',
    // Kept as the raw site key to preserve the Transcript column's current text exactly.
    boardBadge: 'CEBROKER',
    acceptedFlag: 'IsCEBrokerAccreditationAccepted',
    consentName: 'CE Broker',
    consentNameArticle: 'CE Broker',
  },
};

/** Keys of the sites live in this environment, in declaration order. */
export const enabledAccreditationSiteKeys = (): string[] =>
  Object.keys(ACCREDITATION_SITES).filter((key) => ACCREDITATION_SITES[key].isEnabled);

/** True when that site is live in this environment. */
export const isAccreditationSiteEnabled = (siteName: string): boolean =>
  ACCREDITATION_SITES[siteName]?.isEnabled === true;

// Consent sentence fragments, joined in declaration order: with both sites enabled these render
// exactly the wording that was previously hardcoded ("ACCME PARS website or CE Broker" /
// "the ACCME PARS website or CE Broker"); with PARS disabled they collapse to "CE Broker".
export const ACCREDITATION_CONSENT_SITES = enabledAccreditationSiteKeys()
  .map((key) => ACCREDITATION_SITES[key].consentName)
  .join(' or ');

export const ACCREDITATION_CONSENT_SITES_ARTICLE = enabledAccreditationSiteKeys()
  .map((key) => ACCREDITATION_SITES[key].consentNameArticle)
  .join(' or ');

export const ACCREDITATION_MESSAGES = {
  claimAccepted: (siteLabel: string) => `${siteLabel} submission successful.`,
  claimRejected: (siteLabel: string) => `${siteLabel} submission failed.`,
};

//Report URL's
export const ReportURL = 'https://' + env + 'ws.acep.org/AcepToolkit/api/2022/report'

export const ChatBotURL = 'https://www.acep.org/Static/Common/js/external/liveperson.js'
export const CorsURL = "https://cors-anywhere.herokuapp.com/";
export const Token_Header_Key = 'cme_token_header_key';
export const Client_Username = process.env.REACT_APP_CLIENT_USERNAME;
export const Client_Password = process.env.REACT_APP_CLIENT_PASSWORD;
export const MaxLength_FileName = 100; 
export default API_URL;
export const FEATURE_Phase_1_MERGE_CME :boolean = process.env?.REACT_APP_FEATURE_Phase_1_MERGE_CME==='true';
export const FEATURE_Phase_2_MERGE_CME :boolean = process.env?.REACT_APP_FEATURE_Phase_2_MERGE_CME==='true';
export const FEATURE_CME_Req :boolean = process.env?.REACT_APP_FEATURE_CME_Req==='true';
// Master switch for the whole accreditation feature (consent section, consent modal, Transcript
// "Accepted by Boards" column, every /pars/learner/save call). Also false when every site in
// ACCREDITATION_SITES is disabled — with no sites left there is nothing to show or submit, and
// this keeps the feature from rendering half-empty text instead of hiding cleanly.
export const FEATURE_ACCREDITATION_ENABLED :boolean =
  process.env?.REACT_APP_FEATURE_ACCREDITATION_ENABLED === 'true' &&
  enabledAccreditationSiteKeys().length > 0;
export const MERGE_FILE_ENDPOINT_URL = "https://"+ env +"webapps.acep.org/utils/api/ninja/mergefiles"
export const EXCLUDED_LIST_OF_ACTIVITY_TYPES = ["Committee Learning","Learning from Teaching"];
export const SelfReported_CME_Tracking_Status_Id = 5;
export const Finalized_CME_Tracking_Status_Id = 6;
export const None_Topic_Id = 1; 
